import { TComboboxItem } from '@udecode/plate'

export const MENTIONABLES: TComboboxItem<{ email: string }>[] = [
    {
        key: '0',
        text: 'Aayla Secura',
        data: { email: 'aayla_secura@force.com' },
    },
    { key: '1', text: 'Adi Gallia', data: { email: 'adi_gallia@force.com' } },
    {
        key: '2',
        text: 'Admiral Dodd Rancit',
        data: { email: 'admiral_dodd_rancit@force.com' },
    },
    {
        key: '3',
        text: 'Admiral Firmus Piett',
        data: { email: 'admiral_firmus_piett@force.com' },
    },
    {
        key: '4',
        text: 'Admiral Gial Ackbar',
        data: { email: 'admiral_gial_ackbar@force.com' },
    },
    {
        key: '5',
        text: 'Admiral Ozzel',
        data: { email: 'admiral_ozzel@force.com' },
    },
    {
        key: '6',
        text: 'Admiral Raddus',
        data: { email: 'admiral_raddus@force.com' },
    },
    {
        key: '7',
        text: 'Admiral Terrinald Screed',
        data: { email: 'admiral_terrinald_screed@force.com' },
    },
    {
        key: '8',
        text: 'Admiral Trench',
        data: { email: 'admiral_trench@force.com' },
    },
    {
        key: '9',
        text: 'Admiral U.O. Statura',
        data: { email: 'admiral_u.o._statura@force.com' },
    },
    { key: '10', text: 'Agen Kolar', data: { email: 'agen_kolar@force.com' } },
    {
        key: '11',
        text: 'Agent Kallus',
        data: { email: 'agent_kallus@force.com' },
    },
    {
        key: '12',
        text: 'Aiolin and Morit Astarte',
        data: { email: 'aiolin_and_morit_astarte@force.com' },
    },
    { key: '13', text: 'Aks Moe', data: { email: 'aks_moe@force.com' } },
    { key: '14', text: 'Almec', data: { email: 'almec@force.com' } },
    {
        key: '15',
        text: 'Alton Kastle',
        data: { email: 'alton_kastle@force.com' },
    },
    { key: '16', text: 'Amee', data: { email: 'amee@force.com' } },
    { key: '17', text: 'AP-5', data: { email: 'ap-5@force.com' } },
    {
        key: '18',
        text: 'Armitage Hux',
        data: { email: 'armitage_hux@force.com' },
    },
    { key: '19', text: 'Artoo', data: { email: 'artoo@force.com' } },
    {
        key: '20',
        text: 'Arvel Crynyd',
        data: { email: 'arvel_crynyd@force.com' },
    },
    {
        key: '21',
        text: 'Asajj Ventress',
        data: { email: 'asajj_ventress@force.com' },
    },
    { key: '22', text: 'Aurra Sing', data: { email: 'aurra_sing@force.com' } },
    { key: '23', text: 'AZI-3', data: { email: 'azi-3@force.com' } },
    { key: '24', text: 'Bala-Tik', data: { email: 'bala-tik@force.com' } },
    { key: '25', text: 'Barada', data: { email: 'barada@force.com' } },
    {
        key: '26',
        text: 'Bargwill Tomder',
        data: { email: 'bargwill_tomder@force.com' },
    },
    {
        key: '27',
        text: 'Baron Papanoida',
        data: { email: 'baron_papanoida@force.com' },
    },
    {
        key: '28',
        text: 'Barriss Offee',
        data: { email: 'barriss_offee@force.com' },
    },
    {
        key: '29',
        text: 'Baze Malbus',
        data: { email: 'baze_malbus@force.com' },
    },
    {
        key: '30',
        text: 'Bazine Netal',
        data: { email: 'bazine_netal@force.com' },
    },
    { key: '31', text: 'BB-8', data: { email: 'bb-8@force.com' } },
    { key: '32', text: 'BB-9E', data: { email: 'bb-9e@force.com' } },
    {
        key: '33',
        text: 'Ben Quadinaros',
        data: { email: 'ben_quadinaros@force.com' },
    },
    {
        key: '34',
        text: 'Berch Teller',
        data: { email: 'berch_teller@force.com' },
    },
    { key: '35', text: 'Beru Lars', data: { email: 'beru_lars@force.com' } },
    {
        key: '36',
        text: 'Bib Fortuna',
        data: { email: 'bib_fortuna@force.com' },
    },
    {
        key: '37',
        text: 'Biggs Darklighter',
        data: { email: 'biggs_darklighter@force.com' },
    },
    {
        key: '38',
        text: 'Black Krrsantan',
        data: { email: 'black_krrsantan@force.com' },
    },
    {
        key: '39',
        text: 'Bo-Katan Kryze',
        data: { email: 'bo-katan_kryze@force.com' },
    },
    { key: '40', text: 'Boba Fett', data: { email: 'boba_fett@force.com' } },
    { key: '41', text: 'Bobbajo', data: { email: 'bobbajo@force.com' } },
    { key: '42', text: 'Bodhi Rook', data: { email: 'bodhi_rook@force.com' } },
    {
        key: '43',
        text: 'Borvo the Hutt',
        data: { email: 'borvo_the_hutt@force.com' },
    },
    { key: '44', text: 'Boss Nass', data: { email: 'boss_nass@force.com' } },
    { key: '45', text: 'Bossk', data: { email: 'bossk@force.com' } },
    {
        key: '46',
        text: 'Breha Antilles-Organa',
        data: { email: 'breha_antilles-organa@force.com' },
    },
    {
        key: '47',
        text: 'Bren Derlin',
        data: { email: 'bren_derlin@force.com' },
    },
    {
        key: '48',
        text: 'Brendol Hux',
        data: { email: 'brendol_hux@force.com' },
    },
    { key: '49', text: 'BT-1', data: { email: 'bt-1@force.com' } },
    { key: '50', text: 'C-3PO', data: { email: 'c-3po@force.com' } },
    { key: '51', text: 'C1-10P', data: { email: 'c1-10p@force.com' } },
    { key: '52', text: 'Cad Bane', data: { email: 'cad_bane@force.com' } },
    {
        key: '53',
        text: 'Caluan Ematt',
        data: { email: 'caluan_ematt@force.com' },
    },
    {
        key: '54',
        text: 'Captain Gregor',
        data: { email: 'captain_gregor@force.com' },
    },
    {
        key: '55',
        text: 'Captain Phasma',
        data: { email: 'captain_phasma@force.com' },
    },
    {
        key: '56',
        text: 'Captain Quarsh Panaka',
        data: { email: 'captain_quarsh_panaka@force.com' },
    },
    {
        key: '57',
        text: 'Captain Rex',
        data: { email: 'captain_rex@force.com' },
    },
    {
        key: '58',
        text: 'Carlist Rieekan',
        data: { email: 'carlist_rieekan@force.com' },
    },
    {
        key: '59',
        text: 'Casca Panzoro',
        data: { email: 'casca_panzoro@force.com' },
    },
    {
        key: '60',
        text: 'Cassian Andor',
        data: { email: 'cassian_andor@force.com' },
    },
    {
        key: '61',
        text: 'Cassio Tagge',
        data: { email: 'cassio_tagge@force.com' },
    },
    {
        key: '62',
        text: 'Cham Syndulla',
        data: { email: 'cham_syndulla@force.com' },
    },
    {
        key: '63',
        text: 'Che Amanwe Papanoida',
        data: { email: 'che_amanwe_papanoida@force.com' },
    },
    { key: '64', text: 'Chewbacca', data: { email: 'chewbacca@force.com' } },
    {
        key: '65',
        text: 'Chi Eekway Papanoida',
        data: { email: 'chi_eekway_papanoida@force.com' },
    },
    {
        key: '66',
        text: 'Chief Chirpa',
        data: { email: 'chief_chirpa@force.com' },
    },
    {
        key: '67',
        text: 'Chirrut Îmwe',
        data: { email: 'chirrut_îmwe@force.com' },
    },
    { key: '68', text: 'Ciena Ree', data: { email: 'ciena_ree@force.com' } },
    {
        key: '69',
        text: 'Cin Drallig',
        data: { email: 'cin_drallig@force.com' },
    },
    {
        key: '70',
        text: 'Clegg Holdfast',
        data: { email: 'clegg_holdfast@force.com' },
    },
    {
        key: '71',
        text: 'Cliegg Lars',
        data: { email: 'cliegg_lars@force.com' },
    },
    {
        key: '72',
        text: 'Coleman Kcaj',
        data: { email: 'coleman_kcaj@force.com' },
    },
    {
        key: '73',
        text: 'Coleman Trebor',
        data: { email: 'coleman_trebor@force.com' },
    },
    {
        key: '74',
        text: 'Colonel Kaplan',
        data: { email: 'colonel_kaplan@force.com' },
    },
    {
        key: '75',
        text: 'Commander Bly',
        data: { email: 'commander_bly@force.com' },
    },
    {
        key: '76',
        text: 'Commander Cody (CC-2224)',
        data: { email: 'commander_cody_(cc-2224)@force.com' },
    },
    {
        key: '77',
        text: 'Commander Fil (CC-3714)',
        data: { email: 'commander_fil_(cc-3714)@force.com' },
    },
    {
        key: '78',
        text: 'Commander Fox',
        data: { email: 'commander_fox@force.com' },
    },
    {
        key: '79',
        text: 'Commander Gree',
        data: { email: 'commander_gree@force.com' },
    },
    {
        key: '80',
        text: 'Commander Jet',
        data: { email: 'commander_jet@force.com' },
    },
    {
        key: '81',
        text: 'Commander Wolffe',
        data: { email: 'commander_wolffe@force.com' },
    },
    {
        key: '82',
        text: 'Conan Antonio Motti',
        data: { email: 'conan_antonio_motti@force.com' },
    },
    { key: '83', text: 'Conder Kyl', data: { email: 'conder_kyl@force.com' } },
    {
        key: '84',
        text: 'Constable Zuvio',
        data: { email: 'constable_zuvio@force.com' },
    },
    { key: '85', text: 'Cordé', data: { email: 'cordé@force.com' } },
    {
        key: '86',
        text: 'Cpatain Typho',
        data: { email: 'cpatain_typho@force.com' },
    },
    {
        key: '87',
        text: 'Crix Madine',
        data: { email: 'crix_madine@force.com' },
    },
    {
        key: '88',
        text: 'Cut Lawquane',
        data: { email: 'cut_lawquane@force.com' },
    },
    { key: '89', text: 'Dak Ralter', data: { email: 'dak_ralter@force.com' } },
    { key: '90', text: 'Dapp', data: { email: 'dapp@force.com' } },
    { key: '91', text: 'Darth Bane', data: { email: 'darth_bane@force.com' } },
    { key: '92', text: 'Darth Maul', data: { email: 'darth_maul@force.com' } },
    {
        key: '93',
        text: 'Darth Tyranus',
        data: { email: 'darth_tyranus@force.com' },
    },
    {
        key: '94',
        text: 'Daultay Dofine',
        data: { email: 'daultay_dofine@force.com' },
    },
    { key: '95', text: 'Del Meeko', data: { email: 'del_meeko@force.com' } },
    {
        key: '96',
        text: 'Delian Mors',
        data: { email: 'delian_mors@force.com' },
    },
    { key: '97', text: 'Dengar', data: { email: 'dengar@force.com' } },
    {
        key: '98',
        text: 'Depa Billaba',
        data: { email: 'depa_billaba@force.com' },
    },
    {
        key: '99',
        text: 'Derek Klivian',
        data: { email: 'derek_klivian@force.com' },
    },
    {
        key: '100',
        text: 'Dexter Jettster',
        data: { email: 'dexter_jettster@force.com' },
    },
    {
        key: '101',
        text: 'Dineé Ellberger',
        data: { email: 'dineé_ellberger@force.com' },
    },
    { key: '102', text: 'DJ', data: { email: 'dj@force.com' } },
    {
        key: '103',
        text: 'Doctor Aphra',
        data: { email: 'doctor_aphra@force.com' },
    },
    {
        key: '104',
        text: 'Doctor Evazan',
        data: { email: 'doctor_evazan@force.com' },
    },
    { key: '105', text: 'Dogma', data: { email: 'dogma@force.com' } },
    { key: '106', text: 'Dormé', data: { email: 'dormé@force.com' } },
    { key: '107', text: 'Dr. Cylo', data: { email: 'dr._cylo@force.com' } },
    { key: '108', text: 'Droidbait', data: { email: 'droidbait@force.com' } },
    {
        key: '109',
        text: 'Droopy McCool',
        data: { email: 'droopy_mccool@force.com' },
    },
    { key: '110', text: 'Dryden Vos', data: { email: 'dryden_vos@force.com' } },
    { key: '111', text: 'Dud Bolt', data: { email: 'dud_bolt@force.com' } },
    {
        key: '112',
        text: 'Ebe E. Endocott',
        data: { email: 'ebe_e._endocott@force.com' },
    },
    {
        key: '113',
        text: 'Echuu Shen-Jon',
        data: { email: 'echuu_shen-jon@force.com' },
    },
    { key: '114', text: 'Eeth Koth', data: { email: 'eeth_koth@force.com' } },
    {
        key: '115',
        text: 'Eighth Brother',
        data: { email: 'eighth_brother@force.com' },
    },
    { key: '116', text: 'Eirtaé', data: { email: 'eirtaé@force.com' } },
    { key: '117', text: 'Eli Vanto', data: { email: 'eli_vanto@force.com' } },
    { key: '118', text: 'Ellé', data: { email: 'ellé@force.com' } },
    { key: '119', text: 'Ello Asty', data: { email: 'ello_asty@force.com' } },
    { key: '120', text: 'Embo', data: { email: 'embo@force.com' } },
    { key: '121', text: 'Eneb Ray', data: { email: 'eneb_ray@force.com' } },
    { key: '122', text: 'Enfys Nest', data: { email: 'enfys_nest@force.com' } },
    { key: '123', text: 'EV-9D9', data: { email: 'ev-9d9@force.com' } },
    {
        key: '124',
        text: 'Evaan Verlaine',
        data: { email: 'evaan_verlaine@force.com' },
    },
    { key: '125', text: 'Even Piell', data: { email: 'even_piell@force.com' } },
    {
        key: '126',
        text: 'Ezra Bridger',
        data: { email: 'ezra_bridger@force.com' },
    },
    {
        key: '127',
        text: 'Faro Argyus',
        data: { email: 'faro_argyus@force.com' },
    },
    { key: '128', text: 'Feral', data: { email: 'feral@force.com' } },
    {
        key: '129',
        text: 'Fifth Brother',
        data: { email: 'fifth_brother@force.com' },
    },
    {
        key: '130',
        text: 'Finis Valorum',
        data: { email: 'finis_valorum@force.com' },
    },
    { key: '131', text: 'Finn', data: { email: 'finn@force.com' } },
    { key: '132', text: 'Fives', data: { email: 'fives@force.com' } },
    { key: '133', text: 'FN-1824', data: { email: 'fn-1824@force.com' } },
    { key: '134', text: 'FN-2003', data: { email: 'fn-2003@force.com' } },
    {
        key: '135',
        text: 'Fodesinbeed Annodue',
        data: { email: 'fodesinbeed_annodue@force.com' },
    },
    { key: '136', text: 'Fulcrum', data: { email: 'fulcrum@force.com' } },
    { key: '137', text: 'FX-7', data: { email: 'fx-7@force.com' } },
    { key: '138', text: 'GA-97', data: { email: 'ga-97@force.com' } },
    { key: '139', text: 'Galen Erso', data: { email: 'galen_erso@force.com' } },
    {
        key: '140',
        text: 'Gallius Rax',
        data: { email: 'gallius_rax@force.com' },
    },
    {
        key: '141',
        text: 'Garazeb "Zeb" Orrelios',
        data: { email: 'garazeb_"zeb"_orrelios@force.com' },
    },
    {
        key: '142',
        text: 'Gardulla the Hutt',
        data: { email: 'gardulla_the_hutt@force.com' },
    },
    {
        key: '143',
        text: 'Garrick Versio',
        data: { email: 'garrick_versio@force.com' },
    },
    {
        key: '144',
        text: 'Garven Dreis',
        data: { email: 'garven_dreis@force.com' },
    },
    {
        key: '145',
        text: 'Gavyn Sykes',
        data: { email: 'gavyn_sykes@force.com' },
    },
    {
        key: '146',
        text: 'Gideon Hask',
        data: { email: 'gideon_hask@force.com' },
    },
    {
        key: '147',
        text: 'Gizor Dellso',
        data: { email: 'gizor_dellso@force.com' },
    },
    { key: '148', text: 'Gonk droid', data: { email: 'gonk_droid@force.com' } },
    {
        key: '149',
        text: 'Grand Inquisitor',
        data: { email: 'grand_inquisitor@force.com' },
    },
    {
        key: '150',
        text: 'Greeata Jendowanian',
        data: { email: 'greeata_jendowanian@force.com' },
    },
    { key: '151', text: 'Greedo', data: { email: 'greedo@force.com' } },
    {
        key: '152',
        text: 'Greer Sonnel',
        data: { email: 'greer_sonnel@force.com' },
    },
    { key: '153', text: 'Grievous', data: { email: 'grievous@force.com' } },
    { key: '154', text: 'Grummgar', data: { email: 'grummgar@force.com' } },
    { key: '155', text: 'Gungi', data: { email: 'gungi@force.com' } },
    { key: '156', text: 'Hammerhead', data: { email: 'hammerhead@force.com' } },
    { key: '157', text: 'Han Solo', data: { email: 'han_solo@force.com' } },
    {
        key: '158',
        text: 'Harter Kalonia',
        data: { email: 'harter_kalonia@force.com' },
    },
    { key: '159', text: 'Has Obbit', data: { email: 'has_obbit@force.com' } },
    {
        key: '160',
        text: 'Hera Syndulla',
        data: { email: 'hera_syndulla@force.com' },
    },
    { key: '161', text: 'Hevy', data: { email: 'hevy@force.com' } },
    {
        key: '162',
        text: 'Hondo Ohnaka',
        data: { email: 'hondo_ohnaka@force.com' },
    },
    { key: '163', text: 'Huyang', data: { email: 'huyang@force.com' } },
    {
        key: '164',
        text: 'Iden Versio',
        data: { email: 'iden_versio@force.com' },
    },
    { key: '165', text: 'IG-88', data: { email: 'ig-88@force.com' } },
    { key: '166', text: 'Ima-Gun Di', data: { email: 'ima-gun_di@force.com' } },
    {
        key: '167',
        text: 'Inquisitors',
        data: { email: 'inquisitors@force.com' },
    },
    {
        key: '168',
        text: 'Inspector Thanoth',
        data: { email: 'inspector_thanoth@force.com' },
    },
    { key: '169', text: 'Jabba', data: { email: 'jabba@force.com' } },
    {
        key: '170',
        text: 'Jacen Syndulla',
        data: { email: 'jacen_syndulla@force.com' },
    },
    {
        key: '171',
        text: 'Jan Dodonna',
        data: { email: 'jan_dodonna@force.com' },
    },
    { key: '172', text: 'Jango Fett', data: { email: 'jango_fett@force.com' } },
    {
        key: '173',
        text: 'Janus Greejatus',
        data: { email: 'janus_greejatus@force.com' },
    },
    {
        key: '174',
        text: 'Jar Jar Binks',
        data: { email: 'jar_jar_binks@force.com' },
    },
    { key: '175', text: 'Jas Emari', data: { email: 'jas_emari@force.com' } },
    { key: '176', text: 'Jaxxon', data: { email: 'jaxxon@force.com' } },
    {
        key: '177',
        text: 'Jek Tono Porkins',
        data: { email: 'jek_tono_porkins@force.com' },
    },
    {
        key: '178',
        text: 'Jeremoch Colton',
        data: { email: 'jeremoch_colton@force.com' },
    },
    { key: '179', text: 'Jira', data: { email: 'jira@force.com' } },
    {
        key: '180',
        text: 'Jobal Naberrie',
        data: { email: 'jobal_naberrie@force.com' },
    },
    { key: '181', text: 'Jocasta Nu', data: { email: 'jocasta_nu@force.com' } },
    {
        key: '182',
        text: 'Joclad Danva',
        data: { email: 'joclad_danva@force.com' },
    },
    { key: '183', text: 'Joh Yowza', data: { email: 'joh_yowza@force.com' } },
    { key: '184', text: 'Jom Barell', data: { email: 'jom_barell@force.com' } },
    {
        key: '185',
        text: 'Joph Seastriker',
        data: { email: 'joph_seastriker@force.com' },
    },
    {
        key: '186',
        text: 'Jova Tarkin',
        data: { email: 'jova_tarkin@force.com' },
    },
    { key: '187', text: 'Jubnuk', data: { email: 'jubnuk@force.com' } },
    { key: '188', text: 'Jyn Erso', data: { email: 'jyn_erso@force.com' } },
    { key: '189', text: 'K-2SO', data: { email: 'k-2so@force.com' } },
    {
        key: '190',
        text: 'Kanan Jarrus',
        data: { email: 'kanan_jarrus@force.com' },
    },
    { key: '191', text: 'Karbin', data: { email: 'karbin@force.com' } },
    {
        key: '192',
        text: 'Karina the Great',
        data: { email: 'karina_the_great@force.com' },
    },
    {
        key: '193',
        text: 'Kes Dameron',
        data: { email: 'kes_dameron@force.com' },
    },
    { key: '194', text: 'Ketsu Onyo', data: { email: 'ketsu_onyo@force.com' } },
    {
        key: '195',
        text: 'Ki-Adi-Mundi',
        data: { email: 'ki-adi-mundi@force.com' },
    },
    {
        key: '196',
        text: 'King Katuunko',
        data: { email: 'king_katuunko@force.com' },
    },
    { key: '197', text: 'Kit Fisto', data: { email: 'kit_fisto@force.com' } },
    {
        key: '198',
        text: 'Kitster Banai',
        data: { email: 'kitster_banai@force.com' },
    },
    { key: '199', text: 'Klaatu', data: { email: 'klaatu@force.com' } },
    { key: '200', text: 'Klik-Klak', data: { email: 'klik-klak@force.com' } },
    { key: '201', text: 'Korr Sella', data: { email: 'korr_sella@force.com' } },
    { key: '202', text: 'Kylo Ren', data: { email: 'kylo_ren@force.com' } },
    { key: '203', text: 'L3-37', data: { email: 'l3-37@force.com' } },
    { key: '204', text: 'Lama Su', data: { email: 'lama_su@force.com' } },
    {
        key: '205',
        text: 'Lando Calrissian',
        data: { email: 'lando_calrissian@force.com' },
    },
    {
        key: '206',
        text: 'Lanever Villecham',
        data: { email: 'lanever_villecham@force.com' },
    },
    {
        key: '207',
        text: 'Leia Organa',
        data: { email: 'leia_organa@force.com' },
    },
    {
        key: '208',
        text: 'Letta Turmond',
        data: { email: 'letta_turmond@force.com' },
    },
    {
        key: '209',
        text: 'Lieutenant Kaydel Ko Connix',
        data: { email: 'lieutenant_kaydel_ko_connix@force.com' },
    },
    {
        key: '210',
        text: 'Lieutenant Thire',
        data: { email: 'lieutenant_thire@force.com' },
    },
    { key: '211', text: 'Lobot', data: { email: 'lobot@force.com' } },
    { key: '212', text: 'Logray', data: { email: 'logray@force.com' } },
    { key: '213', text: 'Lok Durd', data: { email: 'lok_durd@force.com' } },
    {
        key: '214',
        text: 'Longo Two-Guns',
        data: { email: 'longo_two-guns@force.com' },
    },
    {
        key: '215',
        text: 'Lor San Tekka',
        data: { email: 'lor_san_tekka@force.com' },
    },
    {
        key: '216',
        text: 'Lorth Needa',
        data: { email: 'lorth_needa@force.com' },
    },
    { key: '217', text: 'Lott Dod', data: { email: 'lott_dod@force.com' } },
    {
        key: '218',
        text: 'Luke Skywalker',
        data: { email: 'luke_skywalker@force.com' },
    },
    { key: '219', text: 'Lumat', data: { email: 'lumat@force.com' } },
    {
        key: '220',
        text: 'Luminara Unduli',
        data: { email: 'luminara_unduli@force.com' },
    },
    {
        key: '221',
        text: 'Lux Bonteri',
        data: { email: 'lux_bonteri@force.com' },
    },
    { key: '222', text: 'Lyn Me', data: { email: 'lyn_me@force.com' } },
    { key: '223', text: 'Lyra Erso', data: { email: 'lyra_erso@force.com' } },
    { key: '224', text: 'Mace Windu', data: { email: 'mace_windu@force.com' } },
    { key: '225', text: 'Malakili', data: { email: 'malakili@force.com' } },
    {
        key: '226',
        text: 'Mama the Hutt',
        data: { email: 'mama_the_hutt@force.com' },
    },
    { key: '227', text: 'Mars Guo', data: { email: 'mars_guo@force.com' } },
    { key: '228', text: 'Mas Amedda', data: { email: 'mas_amedda@force.com' } },
    { key: '229', text: 'Mawhonic', data: { email: 'mawhonic@force.com' } },
    { key: '230', text: 'Max Rebo', data: { email: 'max_rebo@force.com' } },
    {
        key: '231',
        text: 'Maximilian Veers',
        data: { email: 'maximilian_veers@force.com' },
    },
    { key: '232', text: 'Maz Kanata', data: { email: 'maz_kanata@force.com' } },
    { key: '233', text: 'ME-8D9', data: { email: 'me-8d9@force.com' } },
    {
        key: '234',
        text: 'Meena Tills',
        data: { email: 'meena_tills@force.com' },
    },
    {
        key: '235',
        text: 'Mercurial Swift',
        data: { email: 'mercurial_swift@force.com' },
    },
    {
        key: '236',
        text: 'Mina Bonteri',
        data: { email: 'mina_bonteri@force.com' },
    },
    {
        key: '237',
        text: 'Miraj Scintel',
        data: { email: 'miraj_scintel@force.com' },
    },
    {
        key: '238',
        text: 'Mister Bones',
        data: { email: 'mister_bones@force.com' },
    },
    { key: '239', text: 'Mod Terrik', data: { email: 'mod_terrik@force.com' } },
    {
        key: '240',
        text: 'Moden Canady',
        data: { email: 'moden_canady@force.com' },
    },
    { key: '241', text: 'Mon Mothma', data: { email: 'mon_mothma@force.com' } },
    {
        key: '242',
        text: 'Moradmin Bast',
        data: { email: 'moradmin_bast@force.com' },
    },
    {
        key: '243',
        text: 'Moralo Eval',
        data: { email: 'moralo_eval@force.com' },
    },
    { key: '244', text: 'Morley', data: { email: 'morley@force.com' } },
    {
        key: '245',
        text: 'Mother Talzin',
        data: { email: 'mother_talzin@force.com' },
    },
    {
        key: '246',
        text: 'Nahdar Vebb',
        data: { email: 'nahdar_vebb@force.com' },
    },
    {
        key: '247',
        text: 'Nahdonnis Praji',
        data: { email: 'nahdonnis_praji@force.com' },
    },
    { key: '248', text: 'Nien Nunb', data: { email: 'nien_nunb@force.com' } },
    {
        key: '249',
        text: 'Niima the Hutt',
        data: { email: 'niima_the_hutt@force.com' },
    },
    { key: '250', text: 'Nines', data: { email: 'nines@force.com' } },
    {
        key: '251',
        text: 'Norra Wexley',
        data: { email: 'norra_wexley@force.com' },
    },
    {
        key: '252',
        text: 'Nute Gunray',
        data: { email: 'nute_gunray@force.com' },
    },
    { key: '253', text: 'Nuvo Vindi', data: { email: 'nuvo_vindi@force.com' } },
    {
        key: '254',
        text: 'Obi-Wan Kenobi',
        data: { email: 'obi-wan_kenobi@force.com' },
    },
    { key: '255', text: 'Odd Ball', data: { email: 'odd_ball@force.com' } },
    {
        key: '256',
        text: 'Ody Mandrell',
        data: { email: 'ody_mandrell@force.com' },
    },
    { key: '257', text: 'Omi', data: { email: 'omi@force.com' } },
    {
        key: '258',
        text: 'Onaconda Farr',
        data: { email: 'onaconda_farr@force.com' },
    },
    { key: '259', text: 'Oola', data: { email: 'oola@force.com' } },
    { key: '260', text: 'OOM-9', data: { email: 'oom-9@force.com' } },
    {
        key: '261',
        text: 'Oppo Rancisis',
        data: { email: 'oppo_rancisis@force.com' },
    },
    {
        key: '262',
        text: 'Orn Free Taa',
        data: { email: 'orn_free_taa@force.com' },
    },
    {
        key: '263',
        text: 'Oro Dassyne',
        data: { email: 'oro_dassyne@force.com' },
    },
    { key: '264', text: 'Orrimarko', data: { email: 'orrimarko@force.com' } },
    { key: '265', text: 'Osi Sobeck', data: { email: 'osi_sobeck@force.com' } },
    { key: '266', text: 'Owen Lars', data: { email: 'owen_lars@force.com' } },
    { key: '267', text: 'Pablo-Jill', data: { email: 'pablo-jill@force.com' } },
    {
        key: '268',
        text: 'Padmé Amidala',
        data: { email: 'padmé_amidala@force.com' },
    },
    {
        key: '269',
        text: 'Pagetti Rook',
        data: { email: 'pagetti_rook@force.com' },
    },
    { key: '270', text: 'Paige Tico', data: { email: 'paige_tico@force.com' } },
    { key: '271', text: 'Paploo', data: { email: 'paploo@force.com' } },
    {
        key: '272',
        text: 'Petty Officer Thanisson',
        data: { email: 'petty_officer_thanisson@force.com' },
    },
    {
        key: '273',
        text: 'Pharl McQuarrie',
        data: { email: 'pharl_mcquarrie@force.com' },
    },
    { key: '274', text: 'Plo Koon', data: { email: 'plo_koon@force.com' } },
    { key: '275', text: 'Po Nudo', data: { email: 'po_nudo@force.com' } },
    {
        key: '276',
        text: 'Poe Dameron',
        data: { email: 'poe_dameron@force.com' },
    },
    {
        key: '277',
        text: 'Poggle the Lesser',
        data: { email: 'poggle_the_lesser@force.com' },
    },
    { key: '278', text: 'Pong Krell', data: { email: 'pong_krell@force.com' } },
    {
        key: '279',
        text: 'Pooja Naberrie',
        data: { email: 'pooja_naberrie@force.com' },
    },
    { key: '280', text: 'PZ-4CO', data: { email: 'pz-4co@force.com' } },
    { key: '281', text: 'Quarrie', data: { email: 'quarrie@force.com' } },
    {
        key: '282',
        text: 'Quay Tolsite',
        data: { email: 'quay_tolsite@force.com' },
    },
    {
        key: '283',
        text: 'Queen Apailana',
        data: { email: 'queen_apailana@force.com' },
    },
    {
        key: '284',
        text: 'Queen Jamillia',
        data: { email: 'queen_jamillia@force.com' },
    },
    {
        key: '285',
        text: 'Queen Neeyutnee',
        data: { email: 'queen_neeyutnee@force.com' },
    },
    {
        key: '286',
        text: 'Qui-Gon Jinn',
        data: { email: 'qui-gon_jinn@force.com' },
    },
    { key: '287', text: 'Quiggold', data: { email: 'quiggold@force.com' } },
    {
        key: '288',
        text: 'Quinlan Vos',
        data: { email: 'quinlan_vos@force.com' },
    },
    { key: '289', text: 'R2-D2', data: { email: 'r2-d2@force.com' } },
    { key: '290', text: 'R2-KT', data: { email: 'r2-kt@force.com' } },
    { key: '291', text: 'R3-S6', data: { email: 'r3-s6@force.com' } },
    { key: '292', text: 'R4-P17', data: { email: 'r4-p17@force.com' } },
    { key: '293', text: 'R5-D4', data: { email: 'r5-d4@force.com' } },
    { key: '294', text: 'RA-7', data: { email: 'ra-7@force.com' } },
    { key: '295', text: 'Rabé', data: { email: 'rabé@force.com' } },
    {
        key: '296',
        text: 'Rako Hardeen',
        data: { email: 'rako_hardeen@force.com' },
    },
    {
        key: '297',
        text: 'Ransolm Casterfo',
        data: { email: 'ransolm_casterfo@force.com' },
    },
    {
        key: '298',
        text: 'Rappertunie',
        data: { email: 'rappertunie@force.com' },
    },
    {
        key: '299',
        text: 'Ratts Tyerell',
        data: { email: 'ratts_tyerell@force.com' },
    },
    {
        key: '300',
        text: 'Raymus Antilles',
        data: { email: 'raymus_antilles@force.com' },
    },
    { key: '301', text: 'Ree-Yees', data: { email: 'ree-yees@force.com' } },
    {
        key: '302',
        text: 'Reeve Panzoro',
        data: { email: 'reeve_panzoro@force.com' },
    },
    { key: '303', text: 'Rey', data: { email: 'rey@force.com' } },
    { key: '304', text: 'Ric Olié', data: { email: 'ric_olié@force.com' } },
    {
        key: '305',
        text: 'Riff Tamson',
        data: { email: 'riff_tamson@force.com' },
    },
    { key: '306', text: 'Riley', data: { email: 'riley@force.com' } },
    {
        key: '307',
        text: 'Rinnriyin Di',
        data: { email: 'rinnriyin_di@force.com' },
    },
    { key: '308', text: 'Rio Durant', data: { email: 'rio_durant@force.com' } },
    {
        key: '309',
        text: 'Rogue Squadron',
        data: { email: 'rogue_squadron@force.com' },
    },
    { key: '310', text: 'Romba', data: { email: 'romba@force.com' } },
    {
        key: '311',
        text: 'Roos Tarpals',
        data: { email: 'roos_tarpals@force.com' },
    },
    { key: '312', text: 'Rose Tico', data: { email: 'rose_tico@force.com' } },
    {
        key: '313',
        text: 'Rotta the Hutt',
        data: { email: 'rotta_the_hutt@force.com' },
    },
    { key: '314', text: 'Rukh', data: { email: 'rukh@force.com' } },
    { key: '315', text: 'Rune Haako', data: { email: 'rune_haako@force.com' } },
    {
        key: '316',
        text: 'Rush Clovis',
        data: { email: 'rush_clovis@force.com' },
    },
    {
        key: '317',
        text: 'Ruwee Naberrie',
        data: { email: 'ruwee_naberrie@force.com' },
    },
    {
        key: '318',
        text: 'Ryoo Naberrie',
        data: { email: 'ryoo_naberrie@force.com' },
    },
    { key: '319', text: 'Sabé', data: { email: 'sabé@force.com' } },
    {
        key: '320',
        text: 'Sabine Wren',
        data: { email: 'sabine_wren@force.com' },
    },
    { key: '321', text: 'Saché', data: { email: 'saché@force.com' } },
    {
        key: '322',
        text: 'Saelt-Marae',
        data: { email: 'saelt-marae@force.com' },
    },
    {
        key: '323',
        text: 'Saesee Tiin',
        data: { email: 'saesee_tiin@force.com' },
    },
    {
        key: '324',
        text: 'Salacious B. Crumb',
        data: { email: 'salacious_b._crumb@force.com' },
    },
    { key: '325', text: 'San Hill', data: { email: 'san_hill@force.com' } },
    {
        key: '326',
        text: 'Sana Starros',
        data: { email: 'sana_starros@force.com' },
    },
    {
        key: '327',
        text: 'Sarco Plank',
        data: { email: 'sarco_plank@force.com' },
    },
    { key: '328', text: 'Sarkli', data: { email: 'sarkli@force.com' } },
    {
        key: '329',
        text: 'Satine Kryze',
        data: { email: 'satine_kryze@force.com' },
    },
    {
        key: '330',
        text: 'Savage Opress',
        data: { email: 'savage_opress@force.com' },
    },
    { key: '331', text: 'Sebulba', data: { email: 'sebulba@force.com' } },
    {
        key: '332',
        text: 'Senator Organa',
        data: { email: 'senator_organa@force.com' },
    },
    {
        key: '333',
        text: 'Sergeant Kreel',
        data: { email: 'sergeant_kreel@force.com' },
    },
    {
        key: '334',
        text: 'Seventh Sister',
        data: { email: 'seventh_sister@force.com' },
    },
    { key: '335', text: 'Shaak Ti', data: { email: 'shaak_ti@force.com' } },
    { key: '336', text: 'Shara Bey', data: { email: 'shara_bey@force.com' } },
    {
        key: '337',
        text: 'Shmi Skywalker',
        data: { email: 'shmi_skywalker@force.com' },
    },
    { key: '338', text: 'Shu Mai', data: { email: 'shu_mai@force.com' } },
    {
        key: '339',
        text: 'Sidon Ithano',
        data: { email: 'sidon_ithano@force.com' },
    },
    { key: '340', text: 'Sifo-Dyas', data: { email: 'sifo-dyas@force.com' } },
    { key: '341', text: 'Sim Aloo', data: { email: 'sim_aloo@force.com' } },
    {
        key: '342',
        text: 'Siniir Rath Velus',
        data: { email: 'siniir_rath_velus@force.com' },
    },
    { key: '343', text: 'Sio Bibble', data: { email: 'sio_bibble@force.com' } },
    {
        key: '344',
        text: 'Sixth Brother',
        data: { email: 'sixth_brother@force.com' },
    },
    { key: '345', text: 'Slowen Lo', data: { email: 'slowen_lo@force.com' } },
    { key: '346', text: 'Sly Moore', data: { email: 'sly_moore@force.com' } },
    {
        key: '347',
        text: 'Snaggletooth',
        data: { email: 'snaggletooth@force.com' },
    },
    {
        key: '348',
        text: 'Snap Wexley',
        data: { email: 'snap_wexley@force.com' },
    },
    { key: '349', text: 'Snoke', data: { email: 'snoke@force.com' } },
    {
        key: '350',
        text: 'Sola Naberrie',
        data: { email: 'sola_naberrie@force.com' },
    },
    { key: '351', text: 'Sora Bulq', data: { email: 'sora_bulq@force.com' } },
    {
        key: '352',
        text: 'Strono Tuggs',
        data: { email: 'strono_tuggs@force.com' },
    },
    {
        key: '353',
        text: 'Sy Snootles',
        data: { email: 'sy_snootles@force.com' },
    },
    {
        key: '354',
        text: 'Tallissan Lintra',
        data: { email: 'tallissan_lintra@force.com' },
    },
    { key: '355', text: 'Tarfful', data: { email: 'tarfful@force.com' } },
    { key: '356', text: 'Tasu Leech', data: { email: 'tasu_leech@force.com' } },
    { key: '357', text: 'Taun We', data: { email: 'taun_we@force.com' } },
    { key: '358', text: 'TC-14', data: { email: 'tc-14@force.com' } },
    {
        key: '359',
        text: 'Tee Watt Kaa',
        data: { email: 'tee_watt_kaa@force.com' },
    },
    { key: '360', text: 'Teebo', data: { email: 'teebo@force.com' } },
    { key: '361', text: 'Teedo', data: { email: 'teedo@force.com' } },
    {
        key: '362',
        text: 'Teemto Pagalies',
        data: { email: 'teemto_pagalies@force.com' },
    },
    {
        key: '363',
        text: 'Temiri Blagg',
        data: { email: 'temiri_blagg@force.com' },
    },
    { key: '364', text: 'Tessek', data: { email: 'tessek@force.com' } },
    { key: '365', text: 'Tey How', data: { email: 'tey_how@force.com' } },
    {
        key: '366',
        text: 'Thane Kyrell',
        data: { email: 'thane_kyrell@force.com' },
    },
    { key: '367', text: 'The Bendu', data: { email: 'the_bendu@force.com' } },
    {
        key: '368',
        text: 'The Smuggler',
        data: { email: 'the_smuggler@force.com' },
    },
    { key: '369', text: 'Thrawn', data: { email: 'thrawn@force.com' } },
    {
        key: '370',
        text: 'Tiaan Jerjerrod',
        data: { email: 'tiaan_jerjerrod@force.com' },
    },
    { key: '371', text: 'Tion Medon', data: { email: 'tion_medon@force.com' } },
    {
        key: '372',
        text: 'Tobias Beckett',
        data: { email: 'tobias_beckett@force.com' },
    },
    {
        key: '373',
        text: 'Tulon Voidgazer',
        data: { email: 'tulon_voidgazer@force.com' },
    },
    { key: '374', text: 'Tup', data: { email: 'tup@force.com' } },
    { key: '375', text: 'U9-C4', data: { email: 'u9-c4@force.com' } },
    {
        key: '376',
        text: 'Unkar Plutt',
        data: { email: 'unkar_plutt@force.com' },
    },
    {
        key: '377',
        text: 'Val Beckett',
        data: { email: 'val_beckett@force.com' },
    },
    {
        key: '378',
        text: 'Vanden Willard',
        data: { email: 'vanden_willard@force.com' },
    },
    {
        key: '379',
        text: 'Vice Admiral Amilyn Holdo',
        data: { email: 'vice_admiral_amilyn_holdo@force.com' },
    },
    { key: '380', text: 'Vober Dand', data: { email: 'vober_dand@force.com' } },
    { key: '381', text: 'WAC-47', data: { email: 'wac-47@force.com' } },
    { key: '382', text: 'Wag Too', data: { email: 'wag_too@force.com' } },
    { key: '383', text: 'Wald', data: { email: 'wald@force.com' } },
    { key: '384', text: 'Walrus Man', data: { email: 'walrus_man@force.com' } },
    { key: '385', text: 'Warok', data: { email: 'warok@force.com' } },
    { key: '386', text: 'Wat Tambor', data: { email: 'wat_tambor@force.com' } },
    { key: '387', text: 'Watto', data: { email: 'watto@force.com' } },
    {
        key: '388',
        text: 'Wedge Antilles',
        data: { email: 'wedge_antilles@force.com' },
    },
    { key: '389', text: 'Wes Janson', data: { email: 'wes_janson@force.com' } },
    {
        key: '390',
        text: 'Wicket W. Warrick',
        data: { email: 'wicket_w._warrick@force.com' },
    },
    {
        key: '391',
        text: 'Wilhuff Tarkin',
        data: { email: 'wilhuff_tarkin@force.com' },
    },
    { key: '392', text: 'Wollivan', data: { email: 'wollivan@force.com' } },
    { key: '393', text: 'Wuher', data: { email: 'wuher@force.com' } },
    {
        key: '394',
        text: 'Wullf Yularen',
        data: { email: 'wullf_yularen@force.com' },
    },
    {
        key: '395',
        text: 'Xamuel Lennox',
        data: { email: 'xamuel_lennox@force.com' },
    },
    { key: '396', text: 'Yaddle', data: { email: 'yaddle@force.com' } },
    {
        key: '397',
        text: 'Yarael Poof',
        data: { email: 'yarael_poof@force.com' },
    },
    { key: '398', text: 'Yoda', data: { email: 'yoda@force.com' } },
    { key: '399', text: 'Zam Wesell', data: { email: 'zam_wesell@force.com' } },
    {
        key: '400',
        text: 'Zev Senesca',
        data: { email: 'zev_senesca@force.com' },
    },
    {
        key: '401',
        text: 'Ziro the Hutt',
        data: { email: 'ziro_the_hutt@force.com' },
    },
    { key: '402', text: 'Zuckuss', data: { email: 'zuckuss@force.com' } },
]
